
import {request} from '../http';
import domain from '../domain';

var ShowService = function(){
    if(domain.env === 'online'){
        this.domain = '//show.51tiangou.com';
    }else{
        this.domain = "//show." + domain.env + ".66buy.com.cn";
    }
};
/**
 * 添加撒娇
 * @param params
 */
ShowService.prototype.crowdAdd  = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/crowd/item/add", params);
};
/**
 * 搭讪
 * @param params
 */
ShowService.prototype.friendRelationAdd = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/friendRelation/add", params);
};
/**
 * 取消关注某人
 * @param params
 */
ShowService.prototype.friendRelationRemove = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/friendRelation/remove", params);
};

/**
 * 删除试衣秀
 * @param params
 */
ShowService.prototype.buyerShowClose = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/buyerShow/close", params);
};

/**
 * 献花
 * @param params
 */
ShowService.prototype.addFlower = function(params = {}){
    var that = this;
    params.needSecKey = true
    params.type = 'POST';
    that._serviceAjaxCom("/buyerShow/addFlower", params);
};

/**
 * 撒娇删除
 * @param params
 */
ShowService.prototype.crowdDelete = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/crowd/item/delete", params);
};

/**
 * 撒娇取消
 * @param params
 */
ShowService.prototype.crowdCancel = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/crowd/item/cancel", params);
};
/**
 * 搜索话题
 */
ShowService.prototype.showSubjectQueryTop = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/showSubject/queryTop", params);
};
/**
 * 添加关注专辑
 */
ShowService.prototype.followAdd=function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/label/follow/add", params);
};
/**
 * 取消关注专辑
 */
ShowService.prototype.followCancel=function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/label/follow/cancel", params);
};
ShowService.prototype._serviceAjaxCom = function(url,params){
    params.url = this.domain + url;
    request(params);
};
/**
 * 专辑详情点赞
 */
ShowService.prototype.labelFlower=function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/labelFlower/add", params);
}
export default new ShowService();
